import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchAiChatList = createAsyncThunk(
    "fetchAiChatList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/aichat/ai-chat-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const AiChatListSlice = createSlice({
    name: "AiChatListSlice",
    initialState,

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAiChatList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAiChatList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(fetchAiChatList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default AiChatListSlice.reducer;
